import React from 'react';

const Bullying = () => {
  return (
    <div id="bullying" className="container">
      <div className="content">
        <div className="mini-content">
          <h2>As a parent, are you doing enough against bullying?</h2>
          <p className="max-width-60">Did you know Bully victims are between 2 to 9 times more likely to consider suicide than non-victims?</p>
          <img src="./img/bullying.jpg" alt="" className="img-space" />
          <h3>A MUST READ</h3>
          <a href="#" target="_blank" className="link-underlined">How To Tell If Your Children Are Being Bullied And What To Do >></a>
          <div className="button-wrapper">
            <a href="" data-leadbox-popup="14614e373f72a2:10e8a98c4f46dc" data-leadbox-domain="tecniquo.lpusercontent.com" className="button">GET THE FREE ANTI-BULLY PDF GUIDE</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Bullying;



// WEBPACK FOOTER //
// ./src/components/home/Bullying.js